import {createEntityService} from 'utils/createEntityService';
import {Credential} from 'types/credential';

export const CredentialService = createEntityService<Credential>({
  baseUrl: 'api/v1/credentials',
  entityName: 'credential',
});
